import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'AvmDate',
    standalone: true,
})
export class AvmDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    /**
     * Formate une date.
     * @param date : Date à formatter
     */
    transform(date: Date): string {
        console.log('AvmDate', date);
        if (date) {
            return this.datePipe.transform(date, 'dd/MM/YYYY');
        } else {
            return '-';
        }
    }
}
